import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '../../../../components/dialog/dialog.types';
import { CommitteeRepository } from '../../../../store/committee-state/committee-state.repository';

interface getCommitteeDeleteObjectProps {
  t: TranslateService;
  store?: CommitteeRepository;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getCommitteeDeleteObject = ({ t, store, representation, action, toggleVisiblity }: getCommitteeDeleteObjectProps): DialogObject => {
  return {
    title: t.instant('settings.committee.delete.title', { representation: representation }),
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'common.dialog.confirm',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'common.dialog.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
